<template>
  <div class="field has-addons">
    <p class="control">
      <button
        class="button is-facebook"
        :class="'is-' + addClass"
        @click="openSocialPopUp('https://www.facebook.com/sharer/sharer.php?u=' + encodedUrl, 'facebook')"
      >
        <span class="icon">
          <i class="fab fa-facebook-f"></i>
        </span>
      </button>
    </p>
    <p class="control">
      <button
        class="button is-twitter"
        :class="'is-' + addClass"
        @click="openSocialPopUp('https://twitter.com/share?url=' + encodedUrl + '&text=' + encodedTitle, 'twitter')"
      >
        <span class="icon">
          <i class="fab fa-twitter"></i>
        </span>
      </button>
    </p>
    <p class="control">
      <button
        class="button is-pinterest"
        :class="'is-' + addClass"
        @click="openSocialPopUp('http://pinterest.com/pin/create/link/?url=' + encodedUrl + '&title=' + encodedTitle, 'pinterest')"
      >
        <span class="icon">
          <i class="fab fa-pinterest"></i>
        </span>
      </button>
    </p>
    <p class="control">
      <button
        class="button is-linkedin"
        :class="'is-' + addClass"
        @click="openSocialPopUp('https://www.linkedin.com/shareArticle?url=' + encodedUrl + '&title=' + encodedTitle, 'linkedin')"
      >
        <span class="icon">
          <i class="fab fa-linkedin-in"></i>
        </span>
      </button>
    </p>
  </div>
</template>

<script>
export default {
  name: "SocialShareButtons",
  props: {
    url: {},
    title: {},
    addClass: { default: "medium" }
  },
  methods: {
    openSocialPopUp(socialUrl, type) {
      var size = null;
      switch (type) {
        case "twitter":
          size = "width=600,height=300";
          break;
        case "facebook":
          size = "width=600,height=800";
          break;
        case "linkedin":
          size = "width=600,height=600";
          break;
        case "pinterest":
          size = "width=757,height=674";
          break;
        default:
          break;
      }
      window.open(socialUrl, "newwindow", size);
    }
  },
  computed: {
    encodedUrl() {
      return encodeURIComponent(this.url);
    },
    encodedTitle() {
      return encodeURIComponent(this.title);
    }
  }
};
</script>

<style>
</style>
